webpackJsonp([244378955794716],{

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(20);
	
	var _IntlLink = __webpack_require__(23);
	
	var _IntlLink2 = _interopRequireDefault(_IntlLink);
	
	var _arrowCircleDown = __webpack_require__(440);
	
	var _arrowCircleDown2 = _interopRequireDefault(_arrowCircleDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsCategories = function (_React$Component) {
	  _inherits(NewsCategories, _React$Component);
	
	  function NewsCategories(props) {
	    _classCallCheck(this, NewsCategories);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { dropdownIsOpen: false };
	    return _this;
	  }
	
	  NewsCategories.prototype.handleOpenDropdown = function handleOpenDropdown(e) {
	    e.preventDefault();
	    this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen });
	  };
	
	  NewsCategories.prototype.render = function render() {
	    var _this2 = this;
	
	    var dropdownIsOpen = this.state.dropdownIsOpen;
	
	    return _react2.default.createElement(
	      'ul',
	      { className: 'news__nav__inner' },
	      _react2.default.createElement(
	        'li',
	        { className: 'news__nav__link' },
	        _react2.default.createElement(
	          _IntlLink2.default,
	          { to: '/p/news', className: 'news__nav__link--category' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'news.categories' })
	        ),
	        _react2.default.createElement(
	          _IntlLink2.default,
	          {
	            to: '#',
	            onClick: function onClick(e) {
	              return _this2.handleOpenDropdown(e);
	            },
	            className: 'news__nav__arrow-down'
	          },
	          _react2.default.createElement('img', { src: _arrowCircleDown2.default })
	        )
	      ),
	      dropdownIsOpen && this.props.allCategories.map(function (category) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'news__nav__link--mobile', key: category.slug + '-mobile' },
	          _react2.default.createElement(
	            _IntlLink2.default,
	            { to: '/category/' + category.slug },
	            category.title
	          )
	        );
	      }),
	      this.props.allCategories.map(function (category) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'news__nav__link--desktop', key: category.slug + '-desktop' },
	          _react2.default.createElement(
	            _IntlLink2.default,
	            { to: '/category/' + category.slug },
	            category.title
	          )
	        );
	      })
	    );
	  };
	
	  return NewsCategories;
	}(_react2.default.Component);
	
	exports.default = NewsCategories;
	module.exports = exports['default'];

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXJyb3ctY2lyY2xlLWRvd248L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yOTgwLjAwMDAwMCwgLTI3NS4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMyMzYuMDAwMDAwLCA1MzEuMDAwMDAwKSBzY2FsZSgxLCAtMSkgdHJhbnNsYXRlKC0zMjM2LjAwMDAwMCwgLTUzMS4wMDAwMDApIHRyYW5zbGF0ZSgyOTg0LjAwMDAwMCwgMjc5LjAwMDAwMCkiPgogICAgICAgICAgICA8cGF0aCBkPSJNMjUyLjAwMDQ5Miw1MDQgQzExMi44MjMzNzcsNTA0IDAsMzkxLjE3NTg1OSAwLDI1MiBDMCwxMTIuODI0MTQxIDExMi44MjMzNzcsMCAyNTIuMDAwNDkyLDAgQzM5MS4xNzU2MzksMCA1MDQsMTEyLjgyNDE0MSA1MDQsMjUyIEM1MDQsMzkxLjE3NTg1OSAzOTEuMTc1NjM5LDUwNCAyNTIuMDAwNDkyLDUwNCBaIiBpZD0iYXJyb3ctY2lyY2xlLWRvd24tY29weSIgZmlsbD0iIzMzMzMzMyI+PC9wYXRoPgogICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIxMTAgMjc4LjQzNjI0OSAxMzAuMDI3IDMwMC43NzEyOTMgMjUyLjExNSAxOTEuMjk1MDc5IDM3NC4yMDMgMzAwLjc3MTI5MyAzOTQuMjMgMjc4LjQzNjI0OSAyNTIuMTE1IDE1MSI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getTransitionStyle = __webpack_require__(30);
	
	var _getTransitionStyle2 = _interopRequireDefault(_getTransitionStyle);
	
	var _Footer = __webpack_require__(58);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _NewsCategories = __webpack_require__(301);
	
	var _NewsCategories2 = _interopRequireDefault(_NewsCategories);
	
	var _Menu = __webpack_require__(52);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _IntlLink = __webpack_require__(23);
	
	var _IntlLink2 = _interopRequireDefault(_IntlLink);
	
	var _PageAnimations = __webpack_require__(59);
	
	var _PageAnimations2 = _interopRequireDefault(_PageAnimations);
	
	var _gatsbyImage = __webpack_require__(70);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbySourceDatocms = __webpack_require__(80);
	
	var _reactIntl = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsIndex = function (_React$Component) {
	  _inherits(NewsIndex, _React$Component);
	
	  function NewsIndex(props) {
	    _classCallCheck(this, NewsIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  NewsIndex.prototype.renderNews = function renderNews(news, sectionAppears) {
	    return _react2.default.createElement(
	      _IntlLink2.default,
	      { to: '/news/' + news.slug + '#title',
	        className: 'news__half__item',
	        style: { backgroundImage: 'url(' + news.cover.resize.src + ')' },
	        key: '' + news.id
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'news__half__container' },
	        _react2.default.createElement(
	          'p',
	          { className: 'page__text' },
	          ' ',
	          news.date,
	          ' '
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'page__title' },
	          ' ',
	          news.title,
	          ' '
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'page__text--abstract' },
	        news.abstract
	      )
	    );
	  };
	
	  NewsIndex.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        data = _props.data,
	        transition = _props.transition,
	        pathContext = _props.pathContext;
	    var _props$data$newsIndex = this.props.data.newsIndex,
	        title = _props$data$newsIndex.title,
	        slug = _props$data$newsIndex.slug;
	
	    var status = transition ? transition.status : "entering";
	    var menuStyle = (0, _getTransitionStyle2.default)(status, 200, 2000, 'menuStyle');
	    var timeout = 800;
	    var delay = 1000;
	
	    var sectionAppears = (0, _getTransitionStyle2.default)(status, timeout, 1000, 'pageAppearsFromBottom');
	
	    var allNews = data.news.edges.map(function (n) {
	      return n.node;
	    });
	
	    if (pathContext.type === "category") {
	      allNews = allNews.filter(function (news) {
	        return news.categories.map(function (c) {
	          return c.slug;
	        }).includes(pathContext.slug);
	      });
	    }
	
	    if (pathContext.type === "tag") {
	      allNews = allNews.filter(function (news) {
	        return news.newsTags.map(function (t) {
	          return t.slug;
	        }).includes(pathContext.slug);
	      });
	    }
	
	    var allCategories = this.props.data.categories.edges.map(function (n) {
	      return n.node;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'page',
	        style: { backgroundColor: "#FFF" }
	      },
	      _react2.default.createElement(_gatsbySourceDatocms.HelmetDatoCms, {
	        seo: data.newsIndex.seo,
	        favicon: data.site.favicon
	      }),
	      _react2.default.createElement(_Menu2.default, {
	        style: menuStyle,
	        hasWhiteLogo: false,
	        data: data
	      }),
	      _react2.default.createElement(_PageAnimations2.default, {
	        status: status,
	        timeout: timeout,
	        delay: timeout,
	        color: '#FFF'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'page__wrapper', style: sectionAppears },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page__title--dark' },
	          pathContext.title ? pathContext.title : title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'news__nav' },
	          _react2.default.createElement(_NewsCategories2.default, { allCategories: allCategories })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap--large' },
	          allNews.length > 0 ? _react2.default.createElement(
	            'div',
	            { className: 'news__half' },
	            allNews.map(function (news) {
	              return _this2.renderNews(news, sectionAppears);
	            })
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              className: 'page__small-title--news',
	              style: sectionAppears,
	              id: 'noContent' })
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, { data: data })
	    );
	  };
	
	  return NewsIndex;
	}(_react2.default.Component);
	
	exports.default = NewsIndex;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-index-js-3f44ca3827f2caf2dc7a.js